import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-d6deec92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-7 pb-7 pt-2 flex lg:flex-row flex-col gap-2 justify-between items-start lg:items-center border-header" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-[16px]" }, "Exportar", -1))
const _hoisted_4 = { class: "px-7 py-7 h-full w-full overflow-auto" }
const _hoisted_5 = { class: "table-auto w-full text-left" }
const _hoisted_6 = { class: "border-header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex px-4 py-2 font-bold" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex gap-4 items-center" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Nombre")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2 font-bold" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex gap-4 items-center justify-center" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Rut")
  ])
], -1))
const _hoisted_10 = { class: "flex gap-4 items-center justify-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "ID A", -1))
const _hoisted_12 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_13 = { class: "flex gap-4 items-center justify-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Total Acc. A", -1))
const _hoisted_15 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_16 = { class: "flex gap-4 items-center justify-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "ID B", -1))
const _hoisted_18 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_19 = { class: "flex gap-4 items-center justify-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Total Acc. B", -1))
const _hoisted_21 = {
  key: 0,
  class: "flex flex-row"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "px-4 py-2 font-bold flex justify-center" }, "Acciones", -1))
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "py-2 h-full" }
const _hoisted_25 = { class: "py-2" }
const _hoisted_26 = {
  key: 0,
  class: "flex"
}
const _hoisted_27 = {
  key: 1,
  class: "flex"
}
const _hoisted_28 = { class: "py-2" }
const _hoisted_29 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_30 = { class: "py-2" }
const _hoisted_31 = { class: "flex justify-center" }
const _hoisted_32 = { class: "py-2" }
const _hoisted_33 = { class: "flex justify-center" }
const _hoisted_34 = { class: "py-2" }
const _hoisted_35 = { class: "flex justify-center" }
const _hoisted_36 = { class: "py-2" }
const _hoisted_37 = { class: "flex justify-center" }
const _hoisted_38 = { class: "py-2" }
const _hoisted_39 = { class: "flex justify-center" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "No hay resultados para mostrar", -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "flex w-full items-center justify-center pt-8 gap-1" }
const _hoisted_47 = { class: "flex items-center" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center my-7" }, " ¿Está seguro que desea eliminar el accionista? ", -1))

import { computed, onBeforeMount, type Ref, ref, watch } from "vue";
import { useRouter } from "vue-router";

import { ShareholderService } from "@/services/shareholder/ShareholderService";
import { ShareholderResume } from "@/services/shareholder/types";

import TextField from "@/components/atoms/TextField.vue";
import NewModal from "@/components/atoms/NewModal.vue";
import ComponentCard from "@/components/atoms/ComponentCard.vue";
import NewShareholderModal from "@/components/organisms/NewShareholderModal.vue";

import { formatRut } from "@/services/utils";

//import * as XLSX from "xlsx";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareholdersTable',
  setup(__props) {

const showNewShareholderModal = ref(false);
const rowSelection = ref<string>();
const idShareholderSelected = ref<number>();
const shareholderService = new ShareholderService();
const router = useRouter();
const shareholders: Ref<ShareholderResume[]> = ref([]);
const searchText = ref("");
const isVisibleConfirmationModal = ref(false);

const currentPage: Ref<number> = ref(1);
const totalPages: Ref<number> = ref(0);
const perPage: Ref<number> = ref(0);
const showFirstPages = computed(() => currentPage.value <= perPage.value);
const showLastPages = computed(
  () => currentPage.value > totalPages.value - perPage.value
);

watch(searchText, () => {
  currentPage.value = 1;
  getShareholders(
    currentPage.value,
    sortField.value,
    isSortAscending.value,
    searchText.value
  );
});

const filteredShareholders = computed(() =>
  sortedShareholders.value.filter((shareholder) => {
    const name = (
      shareholder.firstName +
      " " +
      shareholder.lastName
    ).toLowerCase();
    const nominativeName = shareholder.identificationName?.toLowerCase();
    const search = searchText.value.toLowerCase();
    const rut = shareholder.rut.toLowerCase();
    const businessName = shareholder.businessName?.toLowerCase();
    const investorNumberB = shareholder?.investorNumberB
      ?.toString()
      .toLowerCase();
    return true;
  })
);

const sortField = ref("");
const isSortAscending = ref(true);

const sortedShareholders = computed(() => {
  if (sortField.value) {
    return [...shareholders.value].sort((a, b) => {
      const aValue: any = a[sortField.value as keyof ShareholderResume] || "";
      const bValue: any = b[sortField.value as keyof ShareholderResume] || "";

      if (
        sortField.value === "investorNumberB" ||
        sortField.value === "investorNumberA"
      ) {
        return isSortAscending.value ? aValue - bValue : bValue - aValue;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        const aValueLower = aValue.toLowerCase();
        const bValueLower = bValue.toLowerCase();

        if (aValueLower < bValueLower) {
          return isSortAscending.value ? -1 : 1;
        }
        if (aValueLower > bValueLower) {
          return isSortAscending.value ? 1 : -1;
        }
      }

      return 0;
    });
  }

  return shareholders.value;
});

function changeSortField(field: string) {
  if (sortField.value === field) {
    isSortAscending.value = !isSortAscending.value;
  } else {
    sortField.value = field;
    isSortAscending.value = true;
  }
  getShareholders(
    currentPage.value,
    sortField.value,
    isSortAscending.value,
    searchText.value
  );
}
function deleteHandler(shareholderId: number, e: Event) {
  e.stopPropagation();
  isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value;
  idShareholderSelected.value = shareholderId;
}
function cancelDeleteHandler() {
  isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value;
  idShareholderSelected.value = 0;
}
async function deleteShareholder() {
  if (!idShareholderSelected.value) return false;
  const response = await shareholderService.deleteShareholder(
    idShareholderSelected.value
  );
  if (!response.success) alert("Algo salió mal, vuelva a recargar la página.");
  isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value;
  getShareholders(
    currentPage.value,
    sortField.value,
    isSortAscending.value,
    searchText.value
  );
}

async function getShareholders(
  page: number,
  order = "",
  typeOrder = false,
  search = ""
) {
  const response = await shareholderService.getShareholders(
    page,
    order,
    typeOrder,
    search
  );

  if (!response.success) {
    console.log("Ha ocurrido un error al intentar obtener los accionistas");
    shareholders.value = [];
    return;
  }
  shareholders.value = response.data;
  currentPage.value = response.page;
  totalPages.value = response.total_pages;
  perPage.value = response.per_page;
}

getShareholders(
  currentPage.value,
  sortField.value,
  isSortAscending.value,
  searchText.value
);

const exportToExcel = async () => {
  /*
  const ws = XLSX.utils.json_to_sheet(filteredShareholders.value);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Datos");
  XLSX.writeFile(wb, "lista_accionistas.xlsx");
  */
  await shareholderService.downloadShareholderList();
};

function toShareholderDetail(id: number) {
  router.push({ name: "shareholderDetail", params: { id: id } });
}

/*const totalPages = computed(() =>
      //Math.ceil(props.items.length / perPageSelect.value)
    );*/
const visiblePages = computed(() => {
  if (showFirstPages.value) {
    return Array.from(
      { length: Math.min(perPage.value, totalPages.value) },
      (_, index) => index + 1
    );
  } else if (showLastPages.value) {
    return Array.from(
      { length: Math.min(perPage.value, totalPages.value) },
      (_, index) => totalPages.value - 10 + index
    );
  } else {
    return Array.from(
      { length: perPage.value },
      (_, index) => currentPage.value - 5 + index
    );
  }
});
const goToPage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
    getShareholders(
      currentPage.value,
      sortField.value,
      isSortAscending.value,
      searchText.value
    );
  }
};
const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
    getShareholders(
      currentPage.value,
      sortField.value,
      isSortAscending.value,
      searchText.value
    );
  }
};
const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
    getShareholders(
      currentPage.value,
      sortField.value,
      isSortAscending.value,
      searchText.value
    );
  }
};
const lastPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value = totalPages.value;
    getShareholders(
      currentPage.value,
      sortField.value,
      isSortAscending.value,
      searchText.value
    );
  }
};
const firstPage = () => {
  currentPage.value = 1;
  getShareholders(
    currentPage.value,
    sortField.value,
    isSortAscending.value,
    searchText.value
  );
};

onBeforeMount(() => {
  rowSelection.value = "single";
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ComponentCard, { title: "" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TextField, {
            model: searchText.value,
            "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
            class: "lg:w-4/12 w-full h-[37px]",
            "icon-name": "magnify",
            type: "text",
            name: "search",
            placeholder: "Buscar por nombre o rut",
            "hide-details": ""
          }, null, 8, ["model"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "btn btn-excel h-[35px] w-[170px]",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (exportToExcel()))
            }, [
              _createVNode(_component_mdicon, { name: "file-excel" }),
              _hoisted_3
            ]),
            _createElementVNode("button", {
              class: "btn h-[35px] w-[170px]",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showNewShareholderModal.value = true))
            }, " Nuevo Accionista ")
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("th", {
                  class: "cursor-pointer px-4 py-2 font-bold",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (changeSortField('investor_number_a')))
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    (sortField.value == 'investor_number_a')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          (isSortAscending.value)
                            ? (_openBlock(), _createBlock(_component_mdicon, {
                                key: 0,
                                name: "chevron-up",
                                size: "21"
                              }))
                            : (_openBlock(), _createBlock(_component_mdicon, {
                                key: 1,
                                name: "chevron-down",
                                size: "21"
                              }))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", {
                  class: "cursor-pointer px-4 py-2 font-bold",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (changeSortField('total_shares_a')))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    (sortField.value == 'total_shares_a')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (isSortAscending.value)
                            ? (_openBlock(), _createBlock(_component_mdicon, {
                                key: 0,
                                name: "chevron-up",
                                size: "21"
                              }))
                            : (_openBlock(), _createBlock(_component_mdicon, {
                                key: 1,
                                name: "chevron-down",
                                size: "21"
                              }))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", {
                  class: "cursor-pointer px-4 py-2 font-bold",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (changeSortField('investor_number_b')))
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    (sortField.value == 'investor_number_b')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          (isSortAscending.value)
                            ? (_openBlock(), _createBlock(_component_mdicon, {
                                key: 0,
                                name: "chevron-up",
                                size: "21"
                              }))
                            : (_openBlock(), _createBlock(_component_mdicon, {
                                key: 1,
                                name: "chevron-down",
                                size: "21"
                              }))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", {
                  class: "cursor-pointer px-4 py-2 font-bold",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (changeSortField('total_shares_b')))
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    (sortField.value == 'total_shares_b')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          (isSortAscending.value)
                            ? (_openBlock(), _createBlock(_component_mdicon, {
                                key: 0,
                                name: "chevron-up",
                                size: "21"
                              }))
                            : (_openBlock(), _createBlock(_component_mdicon, {
                                key: 1,
                                name: "chevron-down",
                                size: "21"
                              }))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_22
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredShareholders.value, (shareholder) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: shareholder.id,
                  class: _normalizeClass(["hover:bg-gray-100 cursor-pointer", {
              'text-gray-400':
                shareholder.totalSharesA == 0 && shareholder.totalSharesB == 0,
            }]),
                  onClick: ($event: any) => (toShareholderDetail(shareholder.id))
                }, [
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_mdicon, {
                        name: shareholder.identificationIconName,
                        size: "21"
                      }, null, 8, ["name"])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_25, [
                    (
                  shareholder.businessName == '' ||
                  shareholder.businessName == null
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(shareholder.firstName) + " " + _toDisplayString(shareholder.lastName), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(shareholder.businessName ?? "-"), 1))
                  ]),
                  _createElementVNode("td", _hoisted_28, [
                    (shareholder.identificationRut)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(shareholder.identificationRut
                    ? _unref(formatRut)(shareholder.identificationRut)
                    : "-"), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(shareholder.investorNumberA
                    ? shareholder.investorNumberA
                    : "-"), 1)
                  ]),
                  _createElementVNode("td", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, _toDisplayString(shareholder.totalSharesA ? shareholder.totalSharesA : "-"), 1)
                  ]),
                  _createElementVNode("td", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(shareholder?.investorNumberB
                    ? shareholder?.investorNumberB
                    : "-"), 1)
                  ]),
                  _createElementVNode("td", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(shareholder.totalSharesB ? shareholder.totalSharesB : "-"), 1)
                  ]),
                  _createElementVNode("td", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: (e) => deleteHandler(shareholder.id, e),
                        class: "text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-1 text-center inline-flex items-center mr-2"
                      }, _hoisted_42, 8, _hoisted_40)
                    ])
                  ])
                ], 10, _hoisted_23))
              }), 128))
            ])
          ]),
          (filteredShareholders.value.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_mdicon, {
              class: "border-l-1 cursor-pointer bg-[#008B4E] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50 rounded-full",
              name: "chevron-double-left",
              disabled: currentPage.value === 1,
              onClick: firstPage
            }, null, 8, ["disabled"]),
            _createVNode(_component_mdicon, {
              class: "border-l-1 cursor-pointer bg-[#008B4E] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50 rounded-full",
              name: "chevron-left",
              disabled: currentPage.value === 1,
              onClick: previousPage
            }, null, 8, ["disabled"]),
            _createElementVNode("div", _hoisted_47, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: page,
                  class: _normalizeClass([
              'cursor-pointer',
              'px-3',
              {
                'bg-[#008B4E] text-white font-bold': currentPage.value === page,
                'bg-[#F0F0F0] text-[#969393] ': currentPage.value !== page,
              },
            ]),
                  onClick: ($event: any) => (goToPage(page))
                }, _toDisplayString(page), 11, _hoisted_48))
              }), 128))
            ]),
            _createVNode(_component_mdicon, {
              class: "cursor-pointer bg-[#008B4E] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50 rounded-full",
              name: "chevron-right",
              disabled: currentPage.value === totalPages.value,
              onClick: nextPage
            }, null, 8, ["disabled"]),
            _createVNode(_component_mdicon, {
              class: "cursor-pointer bg-[#008B4E] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50 rounded-full",
              name: "chevron-double-right",
              disabled: currentPage.value === totalPages.value,
              onClick: lastPage
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(NewModal, {
      title: "Eliminar accionista",
      visible: isVisibleConfirmationModal.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value))
    }, {
      default: _withCtx(() => [
        _hoisted_49
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "button-cancel",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (cancelDeleteHandler()))
        }, " Cancelar "),
        _createElementVNode("button", {
          class: "button-delete",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (deleteShareholder()))
        }, " Sí, eliminar ")
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(NewShareholderModal, {
      visible: showNewShareholderModal.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((showNewShareholderModal).value = $event)),
      onReload: getShareholders
    }, null, 8, ["visible"])
  ], 64))
}
}

})